(function(){
  'use strict';
  var menuButton=document.querySelector('[data-menu-toggle]');
  var nav=document.querySelector('[data-site-nav]');
  if(menuButton && nav){
    var closeMenu=function(){nav.classList.remove('is-open');menuButton.setAttribute('aria-expanded','false');menuButton.setAttribute('aria-label','Abrir menu');};
    menuButton.addEventListener('click',function(){var isOpen=nav.classList.toggle('is-open');menuButton.setAttribute('aria-expanded',String(isOpen));menuButton.setAttribute('aria-label',isOpen?'Fechar menu':'Abrir menu');});
    nav.querySelectorAll('a').forEach(function(link){link.addEventListener('click',closeMenu);});
    document.addEventListener('keydown',function(event){if(event.key==='Escape')closeMenu();});
    document.addEventListener('click',function(event){if(!nav.contains(event.target)&&!menuButton.contains(event.target))closeMenu();});
  }
  var serviceSelect=document.getElementById('adao-service');
  document.querySelectorAll('[data-service-link]').forEach(function(link){
    link.addEventListener('click',function(){
      if(!serviceSelect)return;
      var text=link.getAttribute('data-service-link');
      var opts=Array.prototype.slice.call(serviceSelect.options);
      var found=opts.find(function(item){return item.value===text;});
      if(found){serviceSelect.value=text;}
    });
  });
  var variantSelect=document.getElementById('variant-select');
  var displayedPrice=document.querySelector('[data-variant-price]');
  if(variantSelect && displayedPrice){variantSelect.addEventListener('change',function(){var item=variantSelect.options[variantSelect.selectedIndex];if(item && item.dataset.price)displayedPrice.textContent=item.dataset.price;});}
  var notice=document.querySelector('[data-cookie-notice]');
  var dismiss=document.querySelector('[data-cookie-dismiss]');
  if(notice&&dismiss){
    var acknowledged=false;
    try{acknowledged=window.localStorage.getItem('adao-privacy-notice-v1')==='ok';}catch(err){}
    notice.hidden=acknowledged;
    dismiss.addEventListener('click',function(){notice.hidden=true;try{window.localStorage.setItem('adao-privacy-notice-v1','ok');}catch(err){}});
  }
})();
